import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import { toast } from "react-toastify";
import { useProgramCategories, usePrograms } from "../../hooks/useRedux";
import ProgramForm from "./ProgramForm";
import { Program } from "../../store/slices/types";

const AddProgram: React.FC = () => {
  const navigate = useNavigate();
  const { categories: programCategories } = useProgramCategories();
  const { createProgram } = usePrograms();

  const handleSave = async (programData: Partial<Program>) => {
    try {
      const newProgram = {
        title: programData.title || "",
        description: programData.description || "",
        shortDescription: programData.shortDescription || "",
        duration: programData.duration || 0,
        difficulty: programData.difficulty || "beginner",
        categoryId: programData.categoryId || undefined,
        category: programData.category || undefined,
        modules: programData.modules || [],
        isActive:
          programData.isActive !== undefined ? programData.isActive : true,
        color: programData.color || "#667eea",
        tags: programData.tags || [],
        estimatedTimePerDay: programData.estimatedTimePerDay || 20,
        createdBy: "admin",
        createdAt: Date.now(),
        updatedAt: Date.now(),
      };

      await createProgram(newProgram);
      toast.success("program is created");
      navigate("/programs");
    } catch (error) {
      console.error("Failed to create program:", error);
      toast.error(
        `❌ Failed to create program: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const handleCancel = () => {
    navigate("/programs");
  };

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          mb: 4,
        }}
      >
        <Typography variant='h4' fontWeight='700' gutterBottom>
          Create New Program
        </Typography>
        <Typography variant='body1' sx={{ opacity: 0.9 }}>
          Add a new wellness program to your library
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <ProgramForm
          program={null}
          programCategories={programCategories}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </Paper>
    </Box>
  );
};

export default AddProgram;
